import { AsyncAutocompleteSource } from '../../../../../../../../../components/v2/form/AsyncAutocomplete/asyncAutocomplete.types';
import { PaginatedApiFetcher } from '../../../../../../../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { useApplicationContext } from '../../../../../../../../context/ApplicationContext/ApplicationContext';
import { OrderSellerOption } from '../orderGeneralDataOfflineFetchers.types';
import { buildCurrentUserSellerFetcher } from '../orderGeneralDataOfflineFetchers.utils';

interface UseOrderSellerSourceParams {
  shouldFetchSellers: boolean;
  offlineFetcher?: PaginatedApiFetcher<OrderSellerOption>;
}

const useOrderSellerSource = ({
  shouldFetchSellers,
  offlineFetcher,
}: UseOrderSellerSourceParams) => {
  const { isAdminBrand, isSeller, state } = useApplicationContext();

  const currentUserFetcher =
    isSeller && state.user ? buildCurrentUserSellerFetcher(state.user) : undefined;

  const source: AsyncAutocompleteSource = {
    url: 'brands/users',
    queryField: 'name',
    limit: 10,
    order: { name: 'ASC' },
    defaultQuery: { active: !isAdminBrand, roles: ['VENDEDOR', 'ADMIN_MARCA'] },
    enabled: shouldFetchSellers || Boolean(currentUserFetcher),
  };

  return { source, fetcher: currentUserFetcher ?? offlineFetcher };
};

export default useOrderSellerSource;
